import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AuditVisitationService } from './audit-visitation.service';

@Component({
  selector: 'app-audit-visitation',
  templateUrl: './audit-visitation.component.html',
  styleUrls: ['./audit-visitation.component.scss']
})
export class AuditVisitationComponent implements OnInit {
  audits:any;
  constructor(private auditVisitationService: AuditVisitationService,
              private router: Router) { }

  ngOnInit(): void {
    this.getAudits();
  }

  async getAudits(){
    this.audits = await this.auditVisitationService.getAudits();
    console.log('audits', this.audits);

    this.audits.sort((a: any, b: any) => {
      const dateA = a.schedule?.start?.date?._seconds || 0;
      const dateB = b.schedule?.start?.date?._seconds || 0;
      return dateB - dateA;
    });
    
    // console.log('Sorted audits:', this.audits);
  }

  getFormattedDate(date:any){
    // return moment(new Date(date._seconds * 1000)).format('DD-MM-YYYY');
    if (date?._seconds) {
      return moment(new Date(date._seconds * 1000)).format('DD-MM-YYYY');
    }
    return moment(date).format('DD-MM-YYYY');
  }

  onClickView(){
    this.router.navigate(['audit-visitation-builder'])
  }

}
